import SideNavLayout from 'components/Dashboard/SideNavLayout';
import { Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from 'store';
import { selectUser } from 'store/selectors/me/user';

interface PrivateRouteProps {
  children: React.ReactElement;
  showNav?: boolean;
}
const PrivateRoute = ({ children, showNav = true }: PrivateRouteProps) => {
  const user = useAppSelector(selectUser);
  const location = useLocation();
  if (!user) return <Navigate to="/signin" />;

  // Redirect to onboarding if user has no memberships and not currently onboarding
  if (user?.memberships?.length === 0 && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" />;
  }

  return showNav ? (
    <SideNavLayout>
      <Suspense fallback={null}>{children}</Suspense>
    </SideNavLayout>
  ) : (
    <Suspense fallback={null}>{children}</Suspense>
  );
};

export default PrivateRoute;
